import React, { useEffect, useState } from "react";
const SESSION_KEY = "atletismo-resuelto-launch-end";
const INITIAL_SECONDS = 12 * 60 * 60 + 30 * 60 + 27;
function getEndTime() {
  const stored = window.sessionStorage.getItem(SESSION_KEY);
  const parsed = stored ? Number(stored) : 0;
  if (parsed > Date.now()) return parsed;
  const next = Date.now() + INITIAL_SECONDS * 1000;
  window.sessionStorage.setItem(SESSION_KEY, String(next));
  return next;
}
export function Countdown() {
  const [remaining, setRemaining] = useState(INITIAL_SECONDS);
  useEffect(() => {
    let endTime = getEndTime();
    const tick = () => {
      const seconds = Math.max(0, Math.floor((endTime - Date.now()) / 1000));
      if (seconds === 0) {
        endTime = Date.now() + INITIAL_SECONDS * 1000;
        window.sessionStorage.setItem(SESSION_KEY, String(endTime));
        setRemaining(INITIAL_SECONDS);
        return;
      }
      setRemaining(seconds);
    };
    tick();
    const interval = window.setInterval(tick, 1000);
    return () => window.clearInterval(interval);
  }, []);
  const values = [{
    label: "Horas",
    value: Math.floor(remaining / 3600)
  }, {
    label: "Minutos",
    value: Math.floor(remaining % 3600 / 60)
  }, {
    label: "Segundos",
    value: remaining % 60
  }];
  return <div className="flex items-start justify-center gap-1.5 sm:gap-3" role="timer" aria-label="Tiempo restante del precio de lanzamiento" data-id="element-60" data-mp="12rwtew5skopm">
      {values.map((item, index) => <React.Fragment key={item.label} data-id="element-61" data-mp="f4ewynbl12gb" data-mpi={index}>
          <div className="min-w-[62px] rounded-lg border border-[#F5B83D]/25 bg-[#080B14]/80 px-2.5 py-2 text-center shadow-inner sm:min-w-[88px] sm:px-4 sm:py-3" data-id="element-62" data-mp="a40x3sk4wytd">
            <span className="block font-mono text-2xl font-black tabular-nums text-[#FFD66B] sm:text-4xl" data-id="element-63" data-mp="o0nwe1zk812g">
              {String(item.value).padStart(2, "0")}
            </span>
            <span className="mt-0.5 block text-[9px] font-bold uppercase tracking-[0.16em] text-[#8E9AAA] sm:text-[11px]" data-id="element-64" data-mp="1zgcjctctd039">{item.label}</span>
          </div>
          {index < values.length - 1 && <span className="pt-1.5 font-mono text-xl font-bold text-[#C81724] sm:pt-2.5 sm:text-2xl" data-id="element-65" data-mp="s54xt5c6dlmu">:</span>}
        </React.Fragment>)}
    </div>;
}